module.exports = __webpack_public_path__ + "static/media/sponsor_parabola.dec1a8dc.webp";